

function StripTeamTag(playerName, players) {
    let name = String(playerName);

    if (players && players.length > 0) {
        const tags = [...new Set(players.map(p => p.teamTag).filter(t => t))];
        for (const tag of tags) {
            const escaped = tag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').trimEnd();
            name = name.replace(new RegExp(`^${escaped}\\s*`, 'i'), '').trim();
        }
        return name;
    }

    // Fallback to hardcoded regex
    return name
        .replace(/\b(?:3D!|Fox.|M8.|EL.|VES |Liquid`|MTE \||\[CDSG\])\b/gi, '')
        .replace(/(?<=\s|^)(?:3D!|Fox.|M8.|EL.|VES |Liquid`|MTE \||\[CDSG\])(?=\s|$)/gi, '')
        .trim();
}

const TeamIcon = ({ playerName, players, className }) => {
    let icon = null;
    let tag = null;

    if (players && players.length > 0) {
        const match = players.find(p => p.teamTag && String(playerName).startsWith(p.teamTag.trimEnd()));
        if (match && match.teamPictureUrl) {
            icon = match.teamPictureUrl;
            tag = match.teamTag.trim();
        }
    }

    // Fallback to hardcoded checks
    if (!icon) {
        if (String(playerName).startsWith("3D!")) {
            icon = "/TeamIcons/3D.png";
            tag = "3D";
        } else if (String(playerName).startsWith("Fox")) {
            icon = "/TeamIcons/Fox.png";
            tag = "FOX";
        } else if (String(playerName).startsWith("M8")) {
            icon = "/TeamIcons/M8.png";
            tag = "M8";
        } else if (String(playerName).startsWith("EL.")) {
            icon = "/TeamIcons/ELEPHANT.png";
            tag = "EL";
        } else if (String(playerName).startsWith("VES")) {
            icon = "/TeamIcons/VES.png";
            tag = "VES";
        } else if (String(playerName).startsWith("Liquid`")) {
            icon = "/TeamIcons/Liquid.webp";
            tag = "TL";
        } else if (String(playerName).startsWith("MTE")) {
            icon = "/TeamIcons/MTE.png";
            tag = "MTE";
        } else if (String(playerName).startsWith("[CDSG]")) {
            icon = "/TeamIcons/CDSG.png";
            tag = "CDSG";
        }
    }

    if (icon) return (
        <div className={className + " flex flex-col"}>
            <img src={icon} className="aspect-square h-16 min-h-16 -z-10" />
            <h1 className="text-center text-2xl">{tag}</h1>
        </div>
    )
}

export { TeamIcon, StripTeamTag }